var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{staticClass:"noScroll"},[_c('login-form',{attrs:{"logging-in":_vm.loggingIn,"logo-url":"@/assets/images/logo_verovia_horizontal.svg","disable-signup":"","disable-forgot":""},on:{"login":_vm.login}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }